import React from 'react';
import { Card } from "@/components/ui/card";
import { AlertTriangle, RefreshCw, Clock } from 'lucide-react';
import { Button } from "@/components/ui/button";

const MaintenanceMode = ({ message, onRefresh }) => {
  return (
    <div data-testid="maintenance-screen" className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <Card className="bg-slate-800/50 border-slate-700 p-8 max-w-lg w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-amber-500/20 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-amber-400" />
          </div>
        </div>
        
        <h1 data-testid="maintenance-heading" className="text-2xl font-bold text-slate-100 mb-4">
          Platform Under Maintenance
        </h1>
        
        <p data-testid="maintenance-message" className="text-slate-400 mb-6 leading-relaxed">
          {message || "We're currently performing scheduled maintenance to improve your trading experience. Please check back soon."}
        </p>
        
        <div className="flex items-center justify-center space-x-2 text-slate-500 text-sm mb-6">
          <Clock className="w-4 h-4" />
          <span data-testid="maintenance-trading-status">New real-money orders are paused</span>
        </div>
        
        <Button 
          data-testid="maintenance-check-status"
          onClick={onRefresh}
          variant="outline"
          className="border-slate-600 text-slate-300 hover:bg-slate-700"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Check Status
        </Button>
        
        <div className="mt-8 pt-6 border-t border-slate-700">
          <p className="text-slate-500 text-sm">
            Superior Traders Group
          </p>
          <p className="text-slate-600 text-xs mt-1">
            Professional Crypto Trading Platform
          </p>
        </div>
      </Card>
    </div>
  );
};

export default MaintenanceMode;